export default __webpack_public_path__ + "static/Gellix-Bold-ea89118d2a889a614131cdf889cddb2c.ttf";